import { useState } from "react";
import ColorBox from "../Color";
import SizeBox from "../SizeBox";
import { toast } from 'react-hot-toast';

interface IAttributeValuesRender {
    attributeValues: any;
    selectProductDetail: any;
    handleChangeActive: Function;
    isDisable?: boolean;
    is_combo?: boolean;
    data_product?: any
}

const AttributeValuesRender: React.FC<IAttributeValuesRender> = ({ is_combo, attributeValues, selectProductDetail, handleChangeActive, isDisable = false, data_product=[] }) => {
    let [attrValues, setAttrValues] = useState(attributeValues);
    // useEffect(() => {
    //     console.log("attributeValues: ", attributeValues);
    //     setAttrValues(attributeValues);
    // }, [attributeValues]);

    function onActive(id: number, active?: boolean) {
        if(active) {
            return active;
        }else{
            if (is_combo) {
                return selectProductDetail?.attribute_value_ids?.includes(id) ?? false;
            } else {
                return selectProductDetail?.attribute_values?.includes(id) ?? false;
            }
        }
    }

    async function onCheckStock(id_parent?: number, idChoosen?: number) {
        let arr_id_attr_choose:any = [idChoosen];
        // arr_id_attr_choose.push(obj_val.id);
        let copy = JSON.parse(JSON.stringify(attrValues));
        if(copy.length > 0){
            copy.map((attr:any) => {
                let flag = false;
                if(attr.id === id_parent){
                    flag = true;
                }
                
                attr.values.map((obj_val:any, ix:any) => {
                    if(!flag){
                        if(obj_val["active"] == true){
                            arr_id_attr_choose.push(obj_val.id);
                        }else{
                            obj_val.isOut = false;
                        }
                    }
                });
            });
            let flag = false;
            let temp:any = copy.find((x:any)=> x.id == id_parent);
            data_product.map((item:any) => {
                if (item.attribute_values.sort().join("") === arr_id_attr_choose.sort().join("")) {
                    if(temp && temp.values.find((x:any) => x.id == idChoosen)){
                        if(item.amount == 0){
                            flag = true;
                            temp.values.find((x:any) => x.id == idChoosen).isOut = true;
                        }
                        else{
                            temp.values.find((x:any) => x.id == idChoosen).active = true;
                        }
                        
                        return false;
                    }
                }
            });
            if(flag == false){
                temp.values.filter((x:any) => x.id !== idChoosen).map((x:any) => {
                    return x.active = false;
                })
                // return false;
            }else{
                let temp = data_product.find((x:any) => x.attribute_values.indexOf(idChoosen) >= 0 && x.amount > 0)
                if(temp && temp.attribute_values){
                    copy.map((y:any) => {
                        y.values.map((z:any) => {
                            if(temp.attribute_values.indexOf(z.id) >= 0){
                                z.active = true;
                                z.isOut = false;
                            }
                            else{
                                z.active = false;
                            }
                            return z;
                        })
                        return y;
                    })
                }else{
                    toast.error("Thuộc tính đã hết, vui lòng chọn thuộc tính khác");
                }
            }
            handleChangeActive(id_parent, idChoosen, copy);
            setAttrValues(copy);
        }
        
    }

    return <>
        {
            attrValues?.map((item: any) => {
                return <div key={item.id} className='product_detail_right--row'>
                    <span className={`
                        product_detail_right--h 
                        ${is_combo ? "text-[#595959]" : "text-[#434343]  "}
                        ${is_combo ? "" : "font-[700] "}
                        text-[13px] 
                        lg:text-[15px] 
                        lg:leading-[20px]
                        z-[2]
                        `}>{item.name}:</span>
                    <div className='product_detail_right--row--boxes'>
                        {
                            item?.values?.map((value: any) => {
                                return item.is_color ? <ColorBox
                                    onChoose={() => {
                                        onCheckStock(item.id, value.id)
                                    }}
                                    key={value.id}
                                    color={value.value}
                                    isActive={onActive(value.id, value.active)}
                                    isOut={is_combo ? false : isDisable ? false : value.isOut}
                                    isDisable={isDisable}
                                />
                                    : <SizeBox
                                        onChoose={() => {
                                            onCheckStock(item.id, value.id)
                                        }}
                                        key={value.id}
                                        size={value.key}
                                        isActive={onActive(value.id, value.active)}
                                        isOut={is_combo ? false : isDisable ? false : value.isOut}
                                        isDisable={isDisable}
                                    />
                            })
                        }
                    </div>
                </div>
                // return <AttributeValue onCheckStock={onCheckStock} onActive={onActive} isDisable={isDisable} is_combo={is_combo} key={item.id} item={item} handleChangeActive={handleChangeActive} />
            })
        }
    </>
}

export const AttributeValue = ({ ...props }: any) => {
    return <div className='product_detail_right--row'>
        <span className={`
            product_detail_right--h 
            ${props?.is_combo ? "text-[#595959]" : "text-[#434343]  "}
            ${props?.is_combo ? "" : "font-[700] "}
            text-[13px] 
            lg:text-[15px] 
            lg:leading-[20px]
            z-[2]
            `}>{props?.item.name}:</span>
        <div className='product_detail_right--row--boxes'>
            {
                props?.item?.values?.map((value: any) => {
                    return props?.item.is_color ? <ColorBox
                        onChoose={() => {
                            props?.handleChangeActive(props?.item.id, value.id)
                        }}
                        key={value.id}
                        color={value.value}
                        isActive={props?.onActive(value.id, value.active)}
                        isOut={props?.is_combo ? false : props?.isDisable ? false : value.isOut}
                        isDisable={props?.isDisable}
                    />
                        : <SizeBox
                            onChoose={() => {
                                props?.handleChangeActive(props?.item.id, value.id)
                            }}
                            key={value.id}
                            size={value.key}
                            isActive={props?.onActive(value.id, value.active)}
                            isOut={props?.is_combo ? false : props?.isDisable ? false : value.isOut}
                            isDisable={props?.isDisable}
                        />
                })
            }
        </div>
    </div>
}

export default AttributeValuesRender;